<form nz-form [formGroup]="form" nzLayout="vertical">
  <extend-form nz-row [nzGutter]="[20,20]">

    <extend-form-item labelText="Tên tài khoản" nz-col nzMd="12" [errorDefs]="VALIDATORS.userName"
                      [errors]="f.userName.errors"  [showError]="isSubmitted" isRequired>

        <input type="text" nz-input formControlName="userName" placeholder="Chấp nhận chữ, số, dấu _" maxlength="20" autocomplete="off">
    </extend-form-item>

    <extend-form-item labelText="Loại tài khoản" nz-col nzMd="12" isRequired>
      <nz-select style="width: 100%" formControlName="userRole">
        <nz-option *ngFor="let role of roleCanSee" [nzLabel]="role.name" [nzValue]="role.value"></nz-option>
      </nz-select>
    </extend-form-item>

    <extend-form-item labelText="Trạng thái" nz-col nzMd="12" isRequired>
      <nz-select style="width: 100%" formControlName="status" nzPlaceHolder="Trạng thái">
        <nz-option *ngFor="let status of userStatus" [nzLabel]="status.name" [nzValue]="status.value"></nz-option>
      </nz-select>
    </extend-form-item>

    <extend-form-item labelText="Tên người dùng" nz-col nzMd="12" [errorDefs]="VALIDATORS.name"
                      [errors]="f.name.errors"  [showError]="isSubmitted" isRequired>
        <input type="text" nz-input formControlName="name" placeholder="e.g. Trần Văn A" maxlength="30" autocomplete="off">
    </extend-form-item>

    <extend-form-item labelText="Email" nz-col nzMd="12" [errorDefs]="VALIDATORS.email"
                      [errors]="f.email.errors"  [showError]="isSubmitted">
      <app-input-group-icon prefixIcon="at" prefixIconType="TABLER_ICON">
        <input type="email" nz-input formControlName="email" placeholder="e.g. abc@gmail.com" maxlength="20" autocomplete="off">
      </app-input-group-icon>
    </extend-form-item>

    <extend-form-item labelText="Số điện thoại" nz-col nzMd="12" [errorDefs]="VALIDATORS.phoneNumber"
                      [errors]="f.phoneNumber.errors"  [showError]="isSubmitted">
      <app-input-group-icon prefixIcon="phone" prefixIconType="TABLER_ICON">
        <input nz-input formControlName="phoneNumber" placeholder="e.g. 0123456789" maxlength="11" autocomplete="off">
      </app-input-group-icon>
    </extend-form-item>

    <p class="text-uppercase font-weight-bold m-b-0" nz-col nzMd="24">{{data? 'Thay đổi mật khẩu' : 'Nhập mật khẩu'}}</p>
    <extend-form-item labelText="Mật khẩu" nz-col nzMd="12" [errorDefs]="VALIDATORS.password"
                      [errors]="f.password.errors"  [showError]="isSubmitted" [isRequired]="mode === MODE.VIEW">
      <app-input-group-icon prefixIcon="key" prefixIconType="TABLER_ICON"
                            [suffixIcon]="showPassword ? 'eye' : 'eye-off'"
                            suffixIconType="TABLER_ICON"
                            (suffixClickEvent)="showPassword = !showPassword">
        <input [type]="showPassword ? 'text' : 'password'" nz-input formControlName="password" placeholder="e.g. ******" maxlength="20" autocomplete="new-password">
      </app-input-group-icon>
    </extend-form-item>

    <extend-form-item labelText="Nhập lại mật khẩu" nz-col nzMd="12" [errorDefs]="VALIDATORS.repeatPassword"
                      [errors]="f.repeatPassword.errors"  [showError]="isSubmitted" [isRequired]="mode === MODE.VIEW">
      <app-input-group-icon prefixIcon="key" prefixIconType="TABLER_ICON"
                            [suffixIcon]="showRepeatPassword ? 'eye' : 'eye-off'"
                            suffixIconType="TABLER_ICON"
                            (suffixClickEvent)="showRepeatPassword = !showRepeatPassword">
        <input [type]="showRepeatPassword ? 'text' : 'password'" nz-input formControlName="repeatPassword" placeholder="e.g. ******" maxlength="20" >
      </app-input-group-icon>
    </extend-form-item>


  </extend-form>
</form>

<ng-template #editFooter>
  <div class="d-flex justify-content-end">
    <button nz-button (click)="cancel()">Hủy</button>
    <button nz-button nzType="primary" (click)="submitForm()">Lưu</button>
  </div>
</ng-template>
